import { render, staticRenderFns } from "./Duel_Statistics_Header.vue?vue&type=template&id=1c89c3f0&scoped=true&"
import script from "./Duel_Statistics_Header.vue?vue&type=script&lang=js&"
export * from "./Duel_Statistics_Header.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Statistics_Header.vue?vue&type=style&index=0&id=1c89c3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89c3f0",
  null
  
)

export default component.exports